import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { JwtService } from '../../jwt/jwt.service';
import { Router } from '@angular/router';
import { ErrorModel } from '../../common/error.model';
import { environment } from '../../../environments/environment';
import { UserService } from '../../common/api/user.service';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {
  passwordMatch = true;
  oldPassword = '';
  newPassword = '';
  newPasswordCheck = '';

  constructor(private userService: UserService, public jwtService: JwtService, private router: Router,
    private location: Location) { }

  ngOnInit() {
    $('#newPassword').pwstrength({
      common: {minChar: 6, maxChar: 20},
      rules: {
        activated: {
          wordLength: true,
          wordLowercase: true,
          wordOneNumber: true,
          wordNotEmail: false,
          wordSequences: false,
          wordUppercase: false,
          wordOneSpecialChar: true
        }
      },
      ui: {
        showVerdictsInsideProgressBar: true,
        showErrors: true,
        errorMessages: {
          wordLength: '비밀번호가 좀 짧네요~',
          wordLowercase: '영문소문자도 같이 사용해 주세요',
          wordOneNumber: '숫자도 같이 사용하세요',
          wordNotEmail: '이메일주소를 비밀번호로 사용하면 아니아니 아니되오!',
          wordSequences: '연속된 숫자는 보안에 너무 취약해요',
          wordUppercase: '영문대문자도 같이 사용해 주세요',
          wordOneSpecialChar:  '특수문자도 같이 사용해 주세요'
        }
      }
    });

  }

  /**
   * 회원정보 수정 요청
   */
  register() {

  }

  /**
   * 취소
  */
  back() {
    this.location.back();
  }

  passwordCheck() {
    if (this.newPassword !== this.newPasswordCheck) {
      this.passwordMatch = false;
    } else {
      this.passwordMatch = true;
    }
  }

  updatePassword() {
    $('.alert').hide();
    if (this.newPassword !== this.newPasswordCheck) {
      this.passwordMatch = false;
      return;
    }

    if (this.newPassword.length < 1 || this.oldPassword.length < 1) {
      alert('비밀번호를 입력해주세요');
      return;
    }

    this.userService.updatePassword(this.oldPassword, this.newPassword).subscribe(response => {
      alert('비밀번호가 변경되었습니다.');
      this.router.navigate(['/']);
    }, error => {
      console.log(error.json());
      if (error.status === 401 || error.status === 403) {
        alert('로그인이 만료되었거나 잘못된 인증입니다.\n다시 로그인 해주세요');
        this.userService.logout();
      } else {
        if (error.json().error === 'InvalidOldPassword') {
          $('#oldPasswordError').html(error.json().error_description).show();
        } else if (error.json().error === 'InvalidpasswordDto') {
          const description = error.json().error_description;
          if (description.indexOf('6 characters') > 0) {
            $('#newPasswordError').html('비밀번호를 6글자 이상 입력해주세요').show();
          } else if (description.indexOf('least 1 special characters') > 0) {
            $('#newPasswordError').html('특수문자를 하나 이상 입력해주세요').show();
          } else if (description.indexOf('least 1 digit characters') > 0) {
            $('#newPasswordError').html('숫자를 하나 이상 입력해주세요').show();
          }
        } else {
          alert('오류가 발생했습니다.');
        }

      }
    });
  }
}

/**
 * element 입력 여부 체크
 */
function validRequired(ele: FormControl) {

  if (ele.value === '') {
      return {
        valid: false,
        errorMsg: '필수 정보입니다.'
      };
  } else {
    return {
      valid: true,
      errorMsg: ''
    };
  }

}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/user/password/password.component.ts